import React, { useEffect, useState } from 'react';
import { modena_header_bg } from '../../Images';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { setSearchValue, setTypeValue } from '../../Stores/Action/AppAction';
import { useDispatch } from 'react-redux';
import { getTypes } from '../../Services/TypeService';
import { type } from '@testing-library/user-event/dist/type';

const { $ } = window;

const Header = () => {

  const [search, setSearch] = useState('');
  const [asset_type, setAssetType] = useState('');
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    types: [],
    type_name: 'All Files',
    type_icon: 'fa fa-search'
  });

  const useLoc = useLocation();
  //console.log('useLoc', useLoc.pathname)

  const onSelectType = (name, icon) => {
    let typeName = '';
    typeName = name === 'All Files' ? '' : name;
    setAssetType(typeName);
    setState({ ...state, type_name: name, type_icon: icon });
  }

  const toggleDropDown = () => {
    const { types } = state;
    let type = 0;
    types.map((item, i) => {
      type = 50 * i;
    })

    const elm = $('#drop-down');
    const height = parseInt(elm.css('height'));
    if (height < 200) {
      elm.animate({
        height: type,
        opacity: 1,
      }, 250);
    } else {
      elm.animate({
        height: 0,
        opacity: 0,
      }, 250);
    }
  }

  const onSearchChange = e => {
    setSearch(e.target.value);
  }

  const onSearchClick = () => {
    dispatch(setSearchValue(search));
    dispatch(setTypeValue(asset_type));
    navigate('/asset/search');
  }

  const onEnter = e => {
    if (e.keyCode == 13) {
      onSearchClick();
    }
  }

  useEffect(() => {
    const requests = [getTypes({ perpage: 100, filter: `is_active:true`, select: `fa_icon,type_code,type_name` }).then(res => res.data.data)];
    Promise.all(requests).then(results => {
      const [_types] = results;
      setState({ ...state, types: _types });
    });

  }, []);

  const { types, type_name, type_icon } = state;

  return (
    <header className={`masthead ${useLoc.pathname  === '/' || useLoc.pathname  === '/dashboard' ? 'home-background' : 'page-background'}`}>
      <div className="container position-relative px-4 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center">
          <div className={`site-heading ${useLoc.pathname === '/' || useLoc.pathname  === '/dashboard' ? 'site-heading-home' : 'site-heading-page'}`}>
            <div>
              <span className="subheading text_head">
                Design Assets In<br/>One Place.
              </span>
              <div className='wrap_header'>
                
                <div className='wrap_search'>
                  <div className='wrap_search_icon'>
                    <div id="toggleDropDown" onClick={toggleDropDown} style={{  }} className='wrap_dropdown'>
                      <span className={type_icon} style={{ marginRight: 10 }}></span>
                      <span>{type_name}</span>
                      <span className="fa fa-caret-down" style={{ marginLeft: 20}}></span>
                    </div>
                  </div>
                  <span style={{ margin: '15px 0' }}>|</span>
                  <div style={{ flex: 1 }}>
                    <input className='input-search' type="text" value={search} onChange={onSearchChange} onKeyDown={onEnter}
                      placeholder='Search' />
                  </div>
                  <div className='btn-search' style={{}} onClick={onSearchClick}>
                    <span className="fa fa-search" style={{ fontSize: 24 }}></span>
                  </div>
                </div>

                <div id="drop-down" mbutton="toggleDropDown" className='header_drop_down'>
                  <div className='dropdown-ctg' onClick={() => onSelectType('All Files', 'fa fa-search')}>
                        <span className="fa fa-search" style={{ marginRight: 10, fontSize: 14 }}></span> 
                        All Files
                  </div>
                  {
                    types.map((item, i) => (
                      <div key={`item-${i}`} className='dropdown-ctg' onClick={() => onSelectType(item.type_name, item.fa_icon)}>
                        <span className={item.fa_icon} style={{ marginRight: 10, fontSize: 14 }}></span> 
                        {item.type_name}
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;